import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const PersonalTodos = lazyWithRetry(
  () => import("./PersonalTodos"),
  "PersonalTodos",
);

const personalTodosRoutes = buildRoutes([
  {
    path: "/personal-todos",
    element: PersonalTodos,
    roles: [1, 2, 5, 6, 7],
  },
]);

export default personalTodosRoutes;